import { getPreferenceFromCache, setPreference } from "src/services/PreferenceStore";
import { InnerViewFilter, OneViewFilter, stringToView } from "../toLocalStorage";
import { getViews } from "./getViews";
import { stripViewFilterPrefix } from "./stripViewFilterPrefix";

type DeleteOptions = {
    gridKey: string;
    view: OneViewFilter;
};
export const deleteFilter = (options: DeleteOptions): OneViewFilter[] => {
    const { gridKey, view } = options;
    const preferenceKey = stripViewFilterPrefix(gridKey);

    const allPreviousValues = getViews({ gridKey });
    const newFiltersWithoutCurrent = allPreviousValues.reduce((acc, currentValue) => {
        if (currentValue.filterName === view.filterName) {
            return acc;
        }

        acc[currentValue.filterName] = JSON.stringify({
            columnFilters: currentValue.columnFilters,
            columnOrder: currentValue.columnOrder,
            columnVisibility: currentValue.columnVisibility,
        });
        return acc;
    }, {} as InnerViewFilter);

    const newFilters = JSON.stringify(newFiltersWithoutCurrent);

    setPreference("grid.views", preferenceKey, newFiltersWithoutCurrent);

    const currentOrder = getPreferenceFromCache<string[]>("grid.views.order", preferenceKey) ?? [];
    const updatedOrder = currentOrder.filter((name) => name !== view.filterName);
    setPreference("grid.views.order", preferenceKey, updatedOrder);

    const formattedOutput = stringToView(newFilters);
    return formattedOutput;
};
